import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../utils/AuthContext';

function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <header className="header">
      <div className="container">
        <Link to="/" className="logo">
          English Vocabulary Helper
        </Link>
        <div className="nav">
          <Link to="/" className="nav-link">Home</Link>
          {user ? (
            <>
              <Link to="/process" className="nav-link">Process Article</Link>
              <Link to="/vocabulary" className="nav-link">My Vocabulary</Link>
              <button onClick={handleLogout} className="btn btn-small">Logout</button>
            </>
          ) : (
            <>
              <Link to="/login" className="nav-link">Login</Link>
              <Link to="/register" className="nav-link">Register</Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}

export default Header;
